import React from "react";

const AdminDashboardContext = React.createContext({});

export default AdminDashboardContext;
